<div
  class="operating-mode-indicators-container flex flex-row flex-wrap gap-[8px] justify-start items-start"
>
  <ng-content></ng-content>
</div>
